// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/projects/v1/update_vision_board_rules.proto (package protos.vision.projects.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { FieldMask } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_field_mask } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/projects/v1/update_vision_board_rules.proto.
 */
export const file_vision_projects_v1_update_vision_board_rules: GenFile = /*@__PURE__*/
  fileDesc("CjJ2aXNpb24vcHJvamVjdHMvdjEvdXBkYXRlX3Zpc2lvbl9ib2FyZF9ydWxlcy5wcm90bxIZcHJvdG9zLnZpc2lvbi5wcm9qZWN0cy52MSLbAQodVXBkYXRlVmlzaW9uQm9hcmRSdWxlc1JlcXVlc3QSTwoGcGFyYW1zGAEgASgLMj8ucHJvdG9zLnZpc2lvbi5wcm9qZWN0cy52MS5VcGRhdGVWaXNpb25Cb2FyZFJ1bGVzUmVxdWVzdC5QYXJhbXMSLwoLdXBkYXRlX21hc2sYAiABKAsyGi5nb29nbGUucHJvdG9idWYuRmllbGRNYXNrGjgKBlBhcmFtcxISCgpwcm9qZWN0X2lkGAEgASgJEhoKEnZpc2lvbl9ib2FyZF9ydWxlcxgCIAEoCSJ8Ch5VcGRhdGVWaXNpb25Cb2FyZFJ1bGVzUmVzcG9uc2USUAoGcmVzdWx0GAEgASgLMkAucHJvdG9zLnZpc2lvbi5wcm9qZWN0cy52MS5VcGRhdGVWaXNpb25Cb2FyZFJ1bGVzUmVzcG9uc2UuUmVzdWx0GggKBlJlc3VsdGIGcHJvdG8z", [file_google_protobuf_field_mask]);

/**
 * @generated from message protos.vision.projects.v1.UpdateVisionBoardRulesRequest
 */
export type UpdateVisionBoardRulesRequest = Message<"protos.vision.projects.v1.UpdateVisionBoardRulesRequest"> & {
  /**
   * @generated from field: protos.vision.projects.v1.UpdateVisionBoardRulesRequest.Params params = 1;
   */
  params?: UpdateVisionBoardRulesRequest_Params | undefined;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 2;
   */
  updateMask?: FieldMask | undefined;
};

/**
 * Describes the message protos.vision.projects.v1.UpdateVisionBoardRulesRequest.
 * Use `create(UpdateVisionBoardRulesRequestSchema)` to create a new message.
 */
export const UpdateVisionBoardRulesRequestSchema: GenMessage<UpdateVisionBoardRulesRequest> = /*@__PURE__*/
  messageDesc(file_vision_projects_v1_update_vision_board_rules, 0);

/**
 * @generated from message protos.vision.projects.v1.UpdateVisionBoardRulesRequest.Params
 */
export type UpdateVisionBoardRulesRequest_Params = Message<"protos.vision.projects.v1.UpdateVisionBoardRulesRequest.Params"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string vision_board_rules = 2;
   */
  visionBoardRules: string;
};

/**
 * Describes the message protos.vision.projects.v1.UpdateVisionBoardRulesRequest.Params.
 * Use `create(UpdateVisionBoardRulesRequest_ParamsSchema)` to create a new message.
 */
export const UpdateVisionBoardRulesRequest_ParamsSchema: GenMessage<UpdateVisionBoardRulesRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_projects_v1_update_vision_board_rules, 0, 0);

/**
 * @generated from message protos.vision.projects.v1.UpdateVisionBoardRulesResponse
 */
export type UpdateVisionBoardRulesResponse = Message<"protos.vision.projects.v1.UpdateVisionBoardRulesResponse"> & {
  /**
   * @generated from field: protos.vision.projects.v1.UpdateVisionBoardRulesResponse.Result result = 1;
   */
  result?: UpdateVisionBoardRulesResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.projects.v1.UpdateVisionBoardRulesResponse.
 * Use `create(UpdateVisionBoardRulesResponseSchema)` to create a new message.
 */
export const UpdateVisionBoardRulesResponseSchema: GenMessage<UpdateVisionBoardRulesResponse> = /*@__PURE__*/
  messageDesc(file_vision_projects_v1_update_vision_board_rules, 1);

/**
 * @generated from message protos.vision.projects.v1.UpdateVisionBoardRulesResponse.Result
 */
export type UpdateVisionBoardRulesResponse_Result = Message<"protos.vision.projects.v1.UpdateVisionBoardRulesResponse.Result"> & {
};

/**
 * Describes the message protos.vision.projects.v1.UpdateVisionBoardRulesResponse.Result.
 * Use `create(UpdateVisionBoardRulesResponse_ResultSchema)` to create a new message.
 */
export const UpdateVisionBoardRulesResponse_ResultSchema: GenMessage<UpdateVisionBoardRulesResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_projects_v1_update_vision_board_rules, 1, 0);

